import Vue from 'vue';
import { replaceEmpty, dateFns } from '@/common/utils/ways';
export default Vue.extend({
    filters: {
        // 替换空内容
        replaceEmptyFn: function (val, needReplaceEmpty) {
            return needReplaceEmpty ? replaceEmpty(val) : val;
        },
        filterTimeFn: function (val, divider) {
            if (divider === void 0) { divider = '-'; }
            return dateFns.changeTime(val, divider);
        },
    },
    inheritAttrs: false,
    props: {
        // 列表数据
        tableData: {
            type: Array,
            default: function () {
                return [];
            },
        },
        tableLoading: {
            type: Boolean,
            default: true,
        },
        // 字段配置
        /* [
            { prop: 'type_name', label: '类型', minWidth: '80' },
            { prop: 'operation', label: '操作', slotName: 'operation' }
          ] */
        params: {
            type: Array,
            default: function () {
                return [];
            },
        },
        stripe: {
            type: Boolean,
            default: true,
        },
        // 是否需要序号列
        needIndex: {
            type: Boolean,
            default: false,
        },
        // 是否需要多选框
        selection: {
            type: Boolean,
            default: false,
        },
        // 多选框是否固定左侧
        selectionFixed: {
            type: Boolean,
            default: false,
        },
        // 仅对 type=selection 的列有效，类型为 Boolean，为 true 则会在数据更新之后保留之前选中的数据（需指定 row-key）
        reserveSelection: {
            type: Boolean,
            default: false,
        },
        // 是否替换空内容
        needReplaceEmpty: {
            type: Boolean,
            default: true,
        },
        // 使用非index作为key=》面向样式更改后需要修复的操作
        customkey: {
            type: String,
            default: '',
        },
        // 自定义的空数据提示
        customEmptyText: {
            type: String,
            default: '暂无数据',
        },
        // 选项是否禁止
        selectable: {
            type: Function,
            default: function () {
                return true;
            },
        },
    },
    computed: {
        $tableRef: function () {
            return this.$refs.tableRef;
        },
    },
    methods: {
        clearSelection: function () {
            this.$refs.tableRef.clearSelection();
        },
        toggleAllSelection: function () {
            this.$refs.tableRef.toggleAllSelection();
        },
        tableRowClassName: function (_a) {
            var rowIndex = _a.rowIndex;
            return rowIndex % 2 === 1 && this.$props.stripe ? 'single-row' : '';
        },
        toggleRowExpansion: function (row) {
            this.$refs.tableRef.toggleRowExpansion(row);
        },
        setCurrentRow: function (row) {
            this.$refs.tableRef.setCurrentRow(row);
        },
        disposeProp: function (row, prop, unit) {
            var props = prop.split('.');
            var result = null;
            if (props.length > 1) {
                for (var i = 0; i < props.length; i++) {
                    if (i) {
                        result = result[props[i]];
                    }
                    else {
                        result = row[props[i]];
                    }
                    if (!result) {
                        break;
                    }
                }
            }
            else {
                result = row[prop];
            }
            return unit ? replaceEmpty(result) + unit : result;
        },
    },
});
